import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export function getParsedJwt<
  T extends object = { [k: string]: string | number },
>(token: string): T | undefined {
  let result: T | undefined;
  of(token)
    .pipe(
      map((t) => {
        const parts = t.split('.');
        if (parts.length < 2) return undefined as unknown as T;
        let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const pad = b64.length % 4;
        if (pad === 1) return undefined as unknown as T;
        if (pad > 0) b64 += '='.repeat(4 - pad);
        const decoded = atob(b64);
        return JSON.parse(decoded) as T;
      }),
      catchError(() => of(undefined as unknown as T)),
    )
    .subscribe((v) => (result = v));

  return result;
}
